import { safeDefine } from "@breuni-ui/safe-define";
import { Carousel } from "@breuni-ui/carousel";
import { recoCarouselTagName } from "./recoCarouselTagName";
import { descending } from "../utils/descending";

const numberOfSlidesProperty: "--num-slides" = "--num-slides" as const;

const defaultNumberOfSlides: "3.5" = "3.5" as const;

export const numOfSlidesToChooseFrom: Map<number, string> = new Map([
  [0, "2.5"],
  [712, "3.5"],
  [1160, "4.5"],
  [1360, "6.5"],
  [1660, "7.5"],
]);

export const getNumSlidesForCurrentWidth: (
  containerWidth: number,
  numOfSlides: Map<number, string>,
) => string = (containerWidth, numOfSlides) => {
  const widthSpecKey = Array.from(numOfSlides.keys())
    .sort(descending)
    .find((width) => containerWidth >= width);
  if (widthSpecKey !== undefined && containerWidth !== Infinity) {
    return numOfSlides.get(widthSpecKey) || defaultNumberOfSlides;
  }
  return defaultNumberOfSlides;
};

export default class RecoCarousel extends Carousel {
  private resizeObserver: ResizeObserver;

  constructor() {
    super();
    this.resizeObserver = new ResizeObserver((_) => {
      const currentMarginRight = parseInt(
        window
          .getComputedStyle(this)
          .getPropertyValue("margin-right")
          .replace("px", ""),
        10,
      );

      const numOfSlides = getNumSlidesForCurrentWidth(
        this.offsetWidth + currentMarginRight,
        numOfSlidesToChooseFrom,
      );
      this.style.setProperty(numberOfSlidesProperty, numOfSlides);
    });
  }

  connectedCallback(): void {
    super.connectedCallback();
    this.resizeObserver.observe(this);
    window.requestAnimationFrame(() => {
      const numOfSlides = getNumSlidesForCurrentWidth(
        this.offsetWidth,
        numOfSlidesToChooseFrom,
      );
      this.style.setProperty(numberOfSlidesProperty, numOfSlides);
    });
  }

  disconnectedCallback(): void {
    super.disconnectedCallback();
    this.resizeObserver.disconnect();
  }
}

safeDefine(recoCarouselTagName, RecoCarousel);
